import { ActivitySpinnerSize, ActivitySpinnerWidget, ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';

import { Messages } from '../../../codegen/Localize';

/**
 * Save and Revert
 */
const buttonsContainerStyle = style({
  padding: 5,
  borderBottom: `1px solid ${TabStyles.Colors.L2_5}`,
  background: 'white',
  display: 'flex',
});

const innerContainerStyle = style({
  width: 700,
  paddingLeft: 85,
  display: 'flex',
});

export interface SaveRevertButtonProps {
  triggerSave: () => Promise<unknown>;
  triggerRevert: () => Promise<void>;
  triggerResetDefault?: (triggerRevert: () => Promise<void>) => Promise<void>;
  isAnyDirty: boolean;
  isAnyInvalid: boolean;
  isAnySubmitting: boolean;
}

/**
 * Responsible for triggering submit / cancel in a Formik form and showing toasts
 */
export function SaveAndRevertButtons(props: SaveRevertButtonProps) {

  const revertCallback = React.useCallback(
    async () => {
      await props.triggerRevert();
      ToasterService.instance.pop({type: ToastType.Info, text: Messages.settingsReverted()});
    },
    // This deps array was noncompliant before we enabled the lint rule. If you're here, please consider fixing it! See TFS 1257824
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.triggerRevert]
  );

  const resetDefaultCallback = React.useCallback(
    async () => {
      return props.triggerResetDefault?.(props.triggerRevert);
    },
    // This deps array was noncompliant before we enabled the lint rule. If you're here, please consider fixing it! See TFS 1257824
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.triggerRevert, props.triggerResetDefault]
  );

  return (
    <div className={buttonsContainerStyle}>
      <div className={innerContainerStyle}>
        { props.triggerResetDefault &&
          <ButtonWidget
            testId={'reset-settings'}
            buttonType={ButtonType.Outline}
            onClick={resetDefaultCallback}
          >
            {Messages.resetServerSettings_action()}
          </ButtonWidget>}

        <span style={{flex: 1}}/>

        <ButtonWidget
          testId={'revert-settings'} buttonType={ButtonType.Outline}
          disabled={!props.isAnyDirty || props.isAnySubmitting}
          onClick={revertCallback}
          style={{marginRight: 20}}
        >
          {Messages.revert()}
        </ButtonWidget>

        <ButtonWidget
          testId={'save-settings'}
          buttonType={ButtonType.Primary}
          disabled={props.isAnyInvalid || !props.isAnyDirty || props.isAnySubmitting}
          onClick={props.triggerSave}
        >
        <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          {<span style={{
            visibility: props.isAnySubmitting ? null : 'hidden',
            marginLeft: '-35%',
            marginRight: '10%',
          }}>
            <ActivitySpinnerWidget testId={'save-button-spinner'} spinnerSize={ActivitySpinnerSize.Small}/>
          </span>}
          {Messages.save()}
        </span>
        </ButtonWidget>
      </div>
    </div>
  );
}
